import { post, get } from '@/utils/request';
import { ApiResponse } from '@/utils';
import { ToolsTaskParams, ToolsTaskResponse, ToolsTaskSubmitResponse, TranslateParam } from '@/services/types';

// // 小工具任务参数接口
// export interface ToolsTaskParams {
//   model_id_list: string[];
//   number: number;
//   arguments: Array<{ field_name: string; field_value: string | number | boolean }>;
// }

// // 小工具任务响应数据接口
// export interface ToolsTaskResponseData {
//   list: Array<{
//     llm_id: string;
//     unit_credits: number;
//     credits: number;
//     number: number;
//     daily_free_count: number;
//   }>;
//   total_credits: number;
//   user_total_credits: number;
// }

// // 小工具任务响应接口
// export interface ToolsTaskResponse {
//   code: number;
//   data: ToolsTaskResponseData;
//   msg: string;
// }

// // 小工具任务提交响应数据接口
// export interface ToolsTaskSubmitResponseData {
//   msg_iid: string;
//   list: Array<{
//     model_id: string;
//     eta: number;
//   }>;
// }

// // 小工具任务提交响应接口
// export interface ToolsTaskSubmitResponse {
//   code: number;
//   data: ToolsTaskSubmitResponseData;
//   msg: string;
// }

class ToolsService {
  /**
   * 计算小工具任务所需点数
   * @param params 任务参数 { model_id_list, number, arguments }
   * @returns 计算结果，包含总消耗点数和用户剩余点数
   */
  async calculateToolsTaskCredits(params: ToolsTaskParams): Promise<ToolsTaskResponse> {
    // 模拟返回数据
    // const mockResponse: ToolsTaskResponse = {
    //   code: 0,
    //   data: {
    //     list: [
    //       {
    //         llm_id: '01K4P3ENS24SDY733AB017BS62',
    //         unit_credits: 15, // 每张图片消耗15米粒
    //         credits: params.number * 15, // 总消耗米粒
    //         number: params.number,
    //         daily_free_count: 0,
    //       },
    //     ],
    //     total_credits: params.number * 15 * 10, // 转换为内部单位（乘以10）
    //     user_total_credits: 1000, // 模拟用户剩余米粒（500米粒）
    //   },
    //   msg: 'success',
    // };

    // console.log('模拟小工具米粒值计算返回:', mockResponse);
    // return mockResponse;

    // 真实接口调用（暂时注释）
    return post('/task/credits', params) as unknown as ToolsTaskResponse;
  }

  /**
   * 创建小工具工作流生成任务
   * @param params 任务参数 { model_id_list, number, arguments }
   * @returns 任务创建结果，包含任务ID和模型信息
   */
  async submitToolsTask(params: ToolsTaskParams): Promise<ToolsTaskSubmitResponse> {
    // 模拟返回数据
    // const mockResponse: ToolsTaskSubmitResponse = {
    //   code: 0,
    //   data: {
    //     msg_iid: `tools_task_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
    //     list: params.model_id_list.map(modelId => ({
    //       model_id: modelId,
    //       eta: Math.floor(Math.random() * 10),
    //     })),
    //   },
    //   msg: 'success',
    // };

    // console.log('模拟小工具任务提交返回:', mockResponse);
    // return mockResponse;

    // 真实接口调用（暂时注释）
    return post('/task/submit', params) as unknown as ToolsTaskSubmitResponse;
  }

  async queryToolsTask(msgIid: string): Promise<any> {
    return post('/task/query', { msg_iid_list: [msgIid] }) as unknown as any;
  }

  /**
   * 获取运镜模板列表
   * @returns 运镜模板列表
   */
  async getCameraTemplateList(params?: { type: string }): Promise<
    ApiResponse<{
      list: Array<{
        template_id: string;
        asset_id: string;
        img_url: string;
        template_name: string;
        template_description?: string;
        model_type?: string;
      }>;
    }>
  > {
    // // 模拟数据
    // const mockTemplates = [
    //   {
    //     template_id: 'arc',
    //     asset_id: '123',
    //     image_url: 'https://via.placeholder.com/150/FF6D49/FFFFFF?text=弧形运镜',
    //     template_name: '弧形运镜',
    //     template_description: '弧形运动轨迹，适合展现人物的动态美感',
    //   },
    //   {
    //     template_id: '360',
    //     asset_id: '123',
    //     image_url: 'https://via.placeholder.com/150/FF6D49/FFFFFF?text=360环绕',
    //     template_name: '360 度环绕',
    //     template_description: '360度环绕拍摄，全方位展现主体',
    //   },
    //   {
    //     template_id: 'action-run',
    //     asset_id: '123',
    //     image_url: 'https://via.placeholder.com/150/FF6D49/FFFFFF?text=动作奔跑',
    //     template_name: '动作奔跑',
    //     template_description: '动态奔跑镜头，突出运动感和速度感',
    //   },
    // ];

    // console.log('模拟数据mockTemplates', mockTemplates);

    // // 模拟API请求延迟
    // return new Promise(resolve => {
    //   setTimeout(() => {
    //     resolve({
    //       code: 0,
    //       data: {
    //         list: mockTemplates,
    //       },
    //       message: 'success',
    //     });
    //   }, 500); // 模拟500ms的请求延迟
    // });

    // 真实接口调用
    return get('/template/list', params) as unknown as ApiResponse<{
      list: Array<{
        template_id: string;
        asset_id: string;
        img_url: string;
        template_name: string;
        template_description?: string;
        model_type?: string;
      }>;
    }>;

    // 真实接口调用（暂时注释，等后端接口准备好后可以启用）
    // return enhancedRequest.post<{
    //   list: Array<{
    //     template_id: string;
    //     asset_id: string;
    //     image_url: string;
    //     template_name: string;
    //     template_description?: string;
    //   }>;
    // }>('/camera/template/list', params || {}, {
    //   useCache: true,
    //   cacheTTL: 10 * 60 * 1000, // 模板列表缓存10分钟
    //   enableDeduplication: true,
    //   requestKey: 'camera-template-list',
    //   retryCount: 2,
    //   timeout: 10000,
    // });
  }
  async calculateToolsTranslate(params: TranslateParam): Promise<ToolsTaskResponse> {
    // 模拟返回数据
    
    return post('/tool/translate', params) as unknown as ToolsTaskResponse;
  }
}

export default new ToolsService();
